import { useState } from 'react'
import { inviteService } from '../services/inviteService'
import type { RSVPResponse } from '../types'

interface UseInviteResponseResult {
  responding: boolean
  responseError: string | null
  respondToInvite: (
    inviteId: string,
    response: 'yes' | 'no'
  ) => Promise<RSVPResponse | null>
}

export function useInviteResponse(): UseInviteResponseResult {
  const [responding, setResponding] = useState(false)
  const [responseError, setResponseError] = useState<string | null>(null)

  const respondToInvite = async (
    inviteId: string,
    response: 'yes' | 'no'
  ): Promise<RSVPResponse | null> => {
    setResponding(true)
    setResponseError(null)

    try {
      const result = await inviteService.respondToInvite(inviteId, response)
      return result
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to respond to invite'
      setResponseError(errorMessage)
      console.error('Error responding to invite:', error)
      return null
    } finally {
      setResponding(false)
    }
  }

  return {
    responding,
    responseError,
    respondToInvite,
  }
}
